import { render, staticRenderFns } from "./AcessoFiscal.vue?vue&type=template&id=5034a62a&"
import script from "./AcessoFiscal.vue?vue&type=script&lang=js&"
export * from "./AcessoFiscal.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/acessoFiscal.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports